import React from "react";
import ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import "./index.scss";
import App from "./components/App";
import Ledger, { loader as ledgerLoader } from "./components/Ledger/Ledger";
import LedgerForm, { action as ledgerFormAction, loader as ledgerFormLoader } from "./components/Ledger/LedgerForm";
import Users, { loader as usersLoader } from "./components/Users/Users";
import UsersForm, { action as usersFormAction, loader as usersFormLoader } from "./components/Users/UsersForm";
import IncomeStatement from "./components/IncomeStatement/IncomeStatement";
import YearlyIncomeStatement from "./components/IncomeStatement/YearlyIncomeStatement";
import Reports from "./components/Reports/Reports";
import ErrorPage from "./ErrorPage";
import Billing from "./components/Billing/Billing";
import Login from "./components/Auth/Login";
import Signup, { action as signUpAction } from "./components/Auth/Signup";
import SignupSuccess from "./components/Auth/SignupSuccess";
import Home from "./components/Home/Home";
import RoleAccess from "./components/Auth/RoleAccess";
import RecoverPassword, { action as recoverPasswordAction } from './components/Auth/RecoverPassword';
import RecoverPasswordChange, { action as recoverPasswordChangeAction, loader as recoverPasswordChangeLoader } from './components/Auth/RecoverPasswordChange';
import Branches, { loader as branchesLoader } from "./components/Branches/Branches";
import BranchesForm, { action as branchesFormAction, loader as branchesFormLoader } from "./components/Branches/BranchesForm";
import { AuthProvider } from "./hooks/useAuth";
import { ProtectedRoute } from "./components/Auth/ProtectedRoute";
import { ROLES } from './components/_Shared/navigation';

const router = createBrowserRouter([
  {
    path: "/",
    element: <AuthProvider><ProtectedRoute><App/></ProtectedRoute></AuthProvider>,
    errorElement: <ErrorPage/>,
    children: [
      {
        path: "/",
        element: <Home/>,
      },
      {
        path: "/billing",
        element: <Billing/>,
      },
      /* Configuration is not yet implemented
      {
        path: "/config",
        element: <RoleAccess roles={[ROLES.ADMIN]} element={<Configuration/>} />,
      },
      */
      {
        path: "/reports",
        element: <RoleAccess roles={[ROLES.ADMIN]} element={<Reports/>} />,
      },
      {
        path: "/ledger",
        element: <RoleAccess roles={[ROLES.ADMIN, ROLES.RECEPCIONIST]} element={<Ledger/>} />,
        loader: ledgerLoader
      },
      {
        path: "/ledger/new",
        element: <RoleAccess roles={[ROLES.ADMIN, ROLES.RECEPCIONIST]} element={<LedgerForm/>} />,
        loader: ledgerFormLoader,
        action: ledgerFormAction,
      },
      {
        path: "/ledger/edit/:id",
        element: <RoleAccess roles={[ROLES.ADMIN, ROLES.RECEPCIONIST]} element={<LedgerForm/>} />,
        loader: ledgerFormLoader,
        action: ledgerFormAction,
      },
      {
        path: "/income_statement/general",
        element: <RoleAccess roles={[ROLES.ADMIN]} element={<YearlyIncomeStatement/>} />
      },
      {
        path: "/income_statement/details",
        element: <RoleAccess roles={[ROLES.ADMIN]} element={<IncomeStatement/>} />
      },
      {
        path: "/users",
        element: <RoleAccess roles={[ROLES.ADMIN]} element={<Users/>} />,
        loader: usersLoader,
      },
      {
        path: "/users/new",
        element: <RoleAccess roles={[ROLES.ADMIN]} element={<UsersForm/>} />,
        loader: usersFormLoader,
        action: usersFormAction,
      },
      {
        path: "/users/edit/:id",
        element: <RoleAccess roles={[ROLES.ADMIN]} element={<UsersForm/>} />,
        loader: usersFormLoader,
        action: usersFormAction,
      },
      {
        path: "/branches",
        element: <RoleAccess roles={[ROLES.ADMIN]} element={<Branches/>} />,
        loader: branchesLoader,
      },
      {
        path: "/branches/new",
        element: <RoleAccess roles={[ROLES.ADMIN]} element={<BranchesForm/>} />,
        loader: branchesFormLoader,
        action: branchesFormAction,
      },
      {
        path: "/branches/edit/:id",
        element: <RoleAccess roles={[ROLES.ADMIN]} element={<BranchesForm/>} />,
        loader: branchesFormLoader,
        action: branchesFormAction,
      },
    ]
  },
  {
    path: "/login",
    element: <AuthProvider><Login/></AuthProvider>,
    errorElement: <ErrorPage/>
  },
  {
    path: "/recover/password",
    element: <RecoverPassword/>,
    action: recoverPasswordAction,
    errorElement: <ErrorPage/>
  },
  {
    path: "/recover/password/change",
    element: <RecoverPasswordChange/>,
    action: recoverPasswordChangeAction,
    loader: recoverPasswordChangeLoader,
    errorElement: <ErrorPage/>
  },
  {
    path: "/signup",
    element: <Signup/>,
    action: signUpAction,
    errorElement: <ErrorPage/>
  },
  {
    path: "/signup/success",
    element: <SignupSuccess/>,
    errorElement: <ErrorPage/>
  },
  {
    path: "/error",
    element: <ErrorPage/>
  }
]);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <RouterProvider router={router} />
);
